export default __webpack_public_path__ + "static/media/2627 spice rack top.edc2c987.png";